// @flow

import React from 'react';
import type { Node } from 'react';

type Props = {
  html?: string,
};

/**
 * CmsModuleContentHtml
 *
 * @param {Props} props
 * @returns {Node}
 */
export const CmsModuleContentHtml = ({ html }: Props): Node => (
  <div dangerouslySetInnerHTML={{ __html: html }} />
);
